// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xpCn","toggle":"styles_toggle__1k7L9","preview":"styles_preview__1vOVH"};